<template>
  <div class="container">
    <UserSearchWindow @search="search"/>
    <UserSearchResult :userList="userList" :isExistSearchResult="isExistSearchResult"/>
  </div>
</template>

<script>
import UserSearchWindow from '@/components/pages/UserSearchWindow'
import UserSearchResult from '@/components/pages/UserSearchResult'

export default {
  name: 'user-list',

  props: {
    message: null
  },

  data () {
    return {
      screenTitle: '[マスタ設定] ユーザ一覧',
      userList: [],
      isExistSearchResult: false
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  async created () {
    this.$emit('setMessage', this.message, false)
    // ユーザ情報操作（一括取得）API
    await this.axios.get('/api/user/getall', {
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    }).then((response) => {
      this.userList = response.data
      if (this.userList.length > 0) {
        this.isExistSearchResult = true
      } else {
        this.isExistSearchResult = false
      }
    })
  },

  methods: {
    async search (enterpriseCode, sectionCode, userId) {
      this.$emit('setMessage', null, false)
      var params = {
        enterpriseCode: enterpriseCode,
        sectionCode: sectionCode,
        userId: userId
      }
      // ユーザ情報操作（取得）API
      await this.axios.get('/api/user/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.userList = response.data
        if (this.userList.length > 0) {
          this.isExistSearchResult = true
        } else {
          this.isExistSearchResult = false
        }
      })
    }
  },
  components: {
    UserSearchWindow,
    UserSearchResult
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/UserList.vue